import get from 'lodash/get'
import isObject from 'lodash/isObject'
import { appData, storage } from '../../utils'
import { getProcessEnv } from '../../utils/env'

export const getAppData = (key, fallback) => {
	if ( 'undefined' === typeof getAppData.hasData ) {
		getAppData.hasData = isObject(appData.data) && appData.hasData()
	}

	if (getAppData.hasData) {
		return appData.get(key, fallback)
	}

	return get(getDevData, key, fallback)
}

export const isItWp = appData.get('isItWp', storage.local.getItem('isItWp') || getProcessEnv('VUE_APP_WP'))

export const siteId = appData.get('siteId', storage.local.getItem('siteId') || getProcessEnv('VUE_APP_SITE_ID'))

const maybeSplit = val => {
	if ( val && val.split ) {
		val = val.split(',');
	}
	return val;
}

export const siteIds = maybeSplit(appData.get('siteIds', storage.local.getItem('siteIds') || getProcessEnv('VUE_APP_SITE_IDS')))

const allStrings = appData.get('strings', storage.local.getItem('wpStrings'))
export const getWpString = (key, fallback = '') => {
	return allStrings && allStrings[key] ? allStrings[key] : fallback
}

const getDevData = {
	embedCode : '<!-- This site is converting visitors into subscribers and customers with OptinMonster - https://optinmonster.com-->\n<script type="text/javascript" src="https://app.optinmonster.test/wp-content/optinmonster-api-js/dist/Api.js" data-account="5" data-user="24910" data-env="dev" async></script>\n<!-- / OptinMonster -->'
}
